import React, { FC, useState, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import { GET_ALL_REGIONS, GET_ALL_CARRIERS_FILTER } from '../../graphql/client/queries';
import {
    GetAllRegions,
    GetAllRegions_getAllRegions as RegionType,
    GetAllCarriersFilter,
    GetAllCarriersFilter_getAllCarriersFilter as CarrierFilterType,
} from '../../types/schemaTypes';
import { useStoreContext } from '../App/StoreProvider';
import * as MessageListActions from '../../store/actions/messageList';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import CustomToggle from '../Filter/CustomToggle';
import Col from 'react-bootstrap/Col';
import { Routes } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadFilterItem from '../Filter/FilterItem/LoadFilterItem';

interface OptionType {
    // label: string;
    // value: string;
    id: number;
    name: string;
}

interface MessageFilterProps {
    history: any;
    showFilter: boolean;
    showFilterHandler: () => void;
}

const MessageFilters: FC<MessageFilterProps> = (props: MessageFilterProps): React.ReactElement => {
    const [defActiveKey, setDefActiveKey] = useState('0');
    const [regionActiveKey, setRegionActiveKey] = useState('0');
    const [carrierActiveKey, setCarrierActiveKey] = useState('0');
    const [messageActiveKey, setMessageActiveKey] = useState('0');
    const [state, dispatch] = useStoreContext();
    const abortController = new AbortController();
    const [listHeight, setListHeight] = useState(window.screen.height);
    const abortRequest = (): void => {
        abortController.abort();
    };
    const setListContainerHeight = (): void => {
        //begin code for filters
        const filterDiv = document.getElementById('loadsFilterContainer');
        const listDiv = document.getElementById('loadsListContainer');

        let filterHeight = 0;
        // setTimeout in place to avoid animation miscalculations
        setTimeout(() => {
            if (filterDiv) {
                filterHeight = filterDiv.scrollHeight;
            }
            if (listDiv) {
                setListHeight(Math.min(filterHeight));
            }
        }, 100);
    };
    const {
        messageList: { filters, searchPhrase, searchPhraseSubset },
    } = state;
    const { regionIds, messageType, carrierIds } = filters;
    const { regionSubset, carrierSubset } = searchPhraseSubset;

    useEffect((): void => {
        setRegionActiveKey(defActiveKey);
        setMessageActiveKey(defActiveKey);
        setCarrierActiveKey(defActiveKey);
    }, [defActiveKey]);

    // const [selectedRegionIds, setSelectedRegionIds] = useState<number[]>([]);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const carrierFilters: any = [];

    let regions: OptionType[] = [];
    const regionsForSearch: OptionType[] = [];
    if (regionSubset.searchPhrase && regionSubset.searchPhrase.length > 0) {
        regions = regionSubset.subset;
    } else {
        if (regionsData?.getAllRegions) {
            regionsData.getAllRegions.forEach((element: RegionType | null) => {
                if (element?.regionName != null && element?.id != null) {
                    regions.push({
                        id: element.id,
                        name: element.regionName,
                    });
                }
            });
        }
    }
    if (regionsData?.getAllRegions) {
        regionsData.getAllRegions.forEach((element: RegionType | null) => {
            if (element?.regionName != null && element?.id != null) {
                regionsForSearch.push({
                    id: element.id,
                    name: element.regionName,
                });
            }
        });
    }

    let carriers: OptionType[] = [];
    const carriersForSearch: OptionType[] = [];
    if (carrierSubset.searchPhrase && carrierSubset.searchPhrase.length > 0) {
        carriers = carrierSubset.subset;
    } else {
        if (carriersData?.getAllCarriersFilter) {
            carriersData.getAllCarriersFilter.forEach((element: CarrierFilterType | null) => {
                if (element?.name != null && element?.id != null) {
                    carriers.push({
                        id: element.id,
                        name: element.name,
                    });
                }
            });
        }
    }
    if (carriersData?.getAllCarriersFilter) {
        carriersData.getAllCarriersFilter.forEach((element: CarrierFilterType | null) => {
            if (element?.name != null && element?.id != null) {
                carriersForSearch.push({
                    id: element.id,
                    name: element.name,
                });
            }
        });
    }

    const selectRegionHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            // Dispatch Action
            dispatch(MessageListActions.setFiltersForMessages('REGIONS', parseInt(event.target.value), true));
        } else {
            dispatch(MessageListActions.setFiltersForMessages('REGIONS', parseInt(event.target.value), false));
        }
        props.history(`${Routes.MESSAGES.route}`);
    };

    const selectAllRegionHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            MessageListActions.setSelectAllFilters(
                regions.map(region => parseInt(region.id.toString())),
                'REGIONS',
            ),
        );
        props.history(`${Routes.MESSAGES.route}`);
    };

    const selectAllCarrierHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            MessageListActions.setSelectAllFilters(
                carriers.map(carrier => parseInt(carrier.id.toString())),
                'CARRIER',
            ),
        );
        props.history(`${Routes.MESSAGES.route}`);
    };

    const selectCarrierHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            // Dispatch Action
            dispatch(MessageListActions.setFiltersForMessages('CARRIER', parseInt(event.target.value), true));
        } else {
            dispatch(MessageListActions.setFiltersForMessages('CARRIER', parseInt(event.target.value), false));
        }
        props.history(`${Routes.MESSAGES.route}`);
    };

    const selectMessageTypeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            // Dispatch Action
            dispatch(MessageListActions.setFiltersForMessagesType('MESSAGE_TYPE', event.target.value, true));
        } else {
            dispatch(MessageListActions.setFiltersForMessagesType('MESSAGE_TYPE', event.target.value, false));
        }
        props.history(`${Routes.MESSAGES.route}`);
    };

    const selectAllMessageTypeHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            MessageListActions.setSelectAllMessageTypeFilters(
                ['filterByDrivers', 'filterByGroups', 'filterByOnLoad', 'filterByOnShift', 'filterByWaitOnLoad'],
                'MESSAGE_TYPE',
            ),
        );
        props.history(`${Routes.MESSAGES.route}`);
    };

    const updateRegionFilterListForSearch = (searchString: string): void => {
        dispatch(MessageListActions.setFilterSearchPhrase(regionsForSearch, 'REGION', searchString));
    };

    const updateCarrierFilterListForSearch = (searchString: string): void => {
        dispatch(MessageListActions.setFilterSearchPhrase(carriersForSearch, 'CARRIER', searchString));
    };

    // const updateMessageFilterListForSearch = (searchString: string): void => {};
    const halfLength = Math.ceil(regions.length / 2);
    const leftSideItems = regions.slice(0, halfLength);
    const rightSideItems = regions.slice(halfLength, regions.length);
    const leftSideRows: React.ReactElement[] = [];
    leftSideItems.map(region => {
        leftSideRows.push(
            <div className="FilterCheckBox-Container row" key={region.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={region.id.toString()}
                    onChange={selectRegionHandler}
                    checked={regionIds.indexOf(parseInt(region.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{region.name}</span>
            </div>,
        );
    });

    const rightSideRows: React.ReactElement[] = [];
    rightSideItems.map(region => {
        rightSideRows.push(
            <div className="FilterCheckBox-Container row" key={region.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={region.id.toString()}
                    onChange={selectRegionHandler}
                    checked={regionIds.indexOf(parseInt(region.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{region.name}</span>
            </div>,
        );
    });

    const ordering: number[] = [];
    for (let i = 0; i < carrierIds.length; i++) ordering[i] = carrierIds[i];
    carriers.sort(function (a, b) {
        return ordering.indexOf(b.id) - ordering.indexOf(a.id);
    });

    const carriersList: React.ReactElement[] = [];
    carriers.map(carrier => {
        carriersList.push(
            <div className="FilterCheckBox-Container row" key={carrier.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={carrier.id.toString()}
                    onChange={selectCarrierHandler}
                    checked={carrierIds.indexOf(parseInt(carrier.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{carrier.name}</span>
            </div>,
        );
    });

    return (
        <div
            id="MessagesFilterContainer"
            className={props.showFilter ? 'Messages-FiltersContainer' : 'Messages-FiltersContainer hide'}
        >
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <Button
                        className="Filter-SelectAll btn btn-link"
                        variant="link"
                        onClick={(): void => setDefActiveKey(defActiveKey === '0' ? '1' : '0')}
                    >
                        {defActiveKey === '0' ? 'Collapse All' : 'Expand All'}
                    </Button>
                    <FontAwesomeIcon className='Messages-Filter-Close' icon={['fas', 'times-circle']} onClick={props.showFilterHandler} />
                </div>
                <div className='Filter-Body'>
                    <Accordion activeKey={regionActiveKey}>
                        <Card className="FilterItem-Card">
                            <CustomToggle
                                eventKey={regionActiveKey}
                                title="Regions"
                                onClick={(): void => setRegionActiveKey(regionActiveKey === '0' ? '1' : '0')}
                                tags={[]}
                            />
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                    <div className="SearchBar-Container">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="SearchBar-Input"
                                            onChange={event => {
                                                updateRegionFilterListForSearch(event.target.value);
                                            }}
                                            value={searchPhraseSubset.regionSubset.searchPhrase}
                                        />
                                    </div>

                                    <Button
                                        className="FilterItem-SelectAll"
                                        variant="link"
                                        onClick={selectAllRegionHandler}
                                    >
                                        Select All
                                    </Button>
                                    <div className="FilterList-Container container">
                                        <div className="FilterList-Row row">
                                            <Col>{leftSideRows}</Col>
                                            <Col>{rightSideRows}</Col>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>

                    <Accordion activeKey={messageActiveKey}>
                        <Card className="FilterItem-Card">
                            <CustomToggle
                                eventKey={messageActiveKey}
                                title="Driver Status"
                                onClick={(): void => setMessageActiveKey(messageActiveKey === '0' ? '1' : '0')}
                                tags={[]}
                            />
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                    <Button
                                        className="FilterItem-SelectAll"
                                        variant="link"
                                        onClick={selectAllMessageTypeHandler}
                                    >
                                        Select All
                                    </Button>
                                    <div className="FilterList-Container container">
                                        <div className="FilterList-Row row">
                                            <div className="col">
                                                <div className="FilterCheckBox-Container row">
                                                    <input
                                                        type="checkbox"
                                                        className="FilterCheckBox-Checkbox"
                                                        value="filterByOnShift"
                                                        onChange={selectMessageTypeHandler}
                                                        checked={messageType.indexOf('filterByOnShift') > -1 ? true : false}
                                                    />
                                                    <span className="FilterCheckBox-Title">Checked In</span>
                                                </div>
                                                <div className="FilterCheckBox-Container row">
                                                    <input
                                                        type="checkbox"
                                                        className="FilterCheckBox-Checkbox"
                                                        value="filterByWaitOnLoad"
                                                        onChange={selectMessageTypeHandler}
                                                        checked={
                                                            messageType.indexOf('filterByWaitOnLoad') > -1 ? true : false
                                                        }
                                                    />
                                                    <span className="FilterCheckBox-Title">Waiting On Load</span>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="FilterCheckBox-Container row">
                                                    <input
                                                        type="checkbox"
                                                        className="FilterCheckBox-Checkbox"
                                                        value="filterByOnLoad"
                                                        onChange={selectMessageTypeHandler}
                                                        checked={messageType.indexOf('filterByOnLoad') > -1 ? true : false}
                                                    />
                                                    <span className="FilterCheckBox-Title">On Load</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>

                    <Accordion activeKey={carrierActiveKey}>
                        <Card className="FilterItem-Card">
                            <CustomToggle
                                eventKey={carrierActiveKey}
                                title="Carrier"
                                onClick={(): void => setCarrierActiveKey(carrierActiveKey === '0' ? '1' : '0')}
                                tags={[]}
                            />
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                    <div className="SearchBar-Container">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="SearchBar-Input"
                                            onChange={event => {
                                                updateCarrierFilterListForSearch(event.target.value);
                                            }}
                                            value={searchPhraseSubset.carrierSubset.searchPhrase}
                                        />
                                    </div>
                                    <Button
                                        className="FilterItem-SelectAll"
                                        variant="link"
                                        onClick={selectAllCarrierHandler}
                                    >
                                        Select All
                                    </Button>
                                    <div className="FilterList-Container container">
                                        <div className="FilterList-Row row">
                                            <Col>{carriersList}</Col>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
            </div>
        </div>
    );
};

export default MessageFilters;
